<template>
    <div class="page-content">
        <SketchBreadcrumb pageName="Obiective"></SketchBreadcrumb>
        <div class="padding-box">
            <div class="white-box flex space-between align-center">
                <div ref="scrollTo">
                    <h3 class="module-title">Completează cu atenție detaliile cu privire la Obiectivul general (OG) și Obiectivele specifice (OS)</h3>
                    <p>Aceaste informații vor fi introduse in sistemul informatic MySmis. Obiectivele trebuie să fie clare, specifice, măsurabile, realizabile, acceptabile, realiste, legate de timp.</p>
                </div>
                <img src="@/assets/images/M3/M3Sketch/warning-sign.png" class="warning-sign">
            </div>
            <M3Warn v-if="allData && allData.m3_project && allData.m3_project.duplicate_sections && allData.m3_project.duplicate_sections.includes('objectives')" type="yellow" :text="'Această secțiune a fost duplicată din proiectul companiei ' + getCompanyName(allData.m3_project.duplicate_company_id)"></M3Warn>
            <ObiectiveleProiectului :obiective="getObjectives" :all-data="allData" @formComplete="completePage(true)" @formIncomplete="completePage(false)"></ObiectiveleProiectului>
            <b-icon-chevron-up class="back-to-top" @click="scrollToTop()"></b-icon-chevron-up>
        </div>
    </div>
</template>


<script>
    import ObiectiveleProiectului from '@/pages/Aplicatii/M3/M3Sketch/components/obiective-forms/ObiectiveleProiectului'
    import SketchBreadcrumb from '@/pages/Aplicatii/M3/M3Sketch/components/SketchBreadcrumb'
    import { BIconChevronUp } from 'bootstrap-vue'
    import M3Warn from "../components/M3Warn";

    export default {
        components: {
            ObiectiveleProiectului,
            SketchBreadcrumb,
            BIconChevronUp,
            M3Warn
        },

        data() {
            return {
                obiective: null,
                completed: 0,

            }
        },

        mounted() {
            this.$store.dispatch('pageLoading/setLoading', false)
        },

        computed: {
            companies() {
                return this.$store.getters['m3Sketch/companies'];
            },
            getObjectives() {
                return this.allData && this.allData.m3_project && this.allData.m3_project.objectives ? {
                    obiective: this.allData.m3_project.objectives.objectives,
                    checked: this.allData.m3_project.objectives.checked,
                    diferentaCA: this.allData.turnover_difference,
                    angajati: this.allData.employees,
                } : {}
            },
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },

        methods: {
            getCompanyName(id){
                let name = '';
                this.companies.forEach(company => {
                    if(Number(company.id) === Number(id))
                        name = company.name
                })

                return name;
            },
            scrollToTop() {
                this.$refs.scrollTo.scrollIntoView({behavior: 'smooth', block: "center"});
            },
            completePage(event) {
                this.section = {
                    section: 'obiective'
                }

                this.completed = event

                if(this.completed){
                    this.$store.dispatch('pages/addPage', this.section)
                } else {
                    this.$store.dispatch('pages/removePage', this.section)
                }
            },
        }
    }
</script>

<style scoped>
.back-to-top{
    cursor: pointer;
    position: sticky;
    bottom: -10px;
    left: 100%;
    color: #fff;
    z-index: 99999;
    padding: 4px;
    border-radius: 4px;
    font-size: 25px;
    background: #8c6984;
}
.space-between{
    justify-content: space-between;
}
.white-box{
    background: #fff;
    padding: 20px;
}
.module-title{
    margin: 0;
    color: #5b6276;
    font-size: 14px;
    margin-bottom: 5px;
}
.white-box{
    width: 100%;
}
.white-box p{
    color: #777e90;
    font-size: 12px;
    margin: 0;
    max-width: 960px;
}
.warning-sign{
    margin-left: 50px;
}

</style>
